import { Controller } from '@hotwired/stimulus'

declare const Stripe: any

export default class extends Controller {
  static targets = [
    'cardElement',
    'cardErrors'
  ]

  static values = {
    stripePublishableKey: String,
    mode: String
  }

  declare cardElementTarget: HTMLDivElement
  declare cardErrorsTarget: HTMLDivElement
  declare hasCardErrorsTarget: boolean
  declare stripePublishableKeyValue: string
  declare modeValue: string

  private stripe: any
  private cardElement: any
  private elements: any

  connect() {
    console.log('[CardComponent] Controller connected', { mode: this.modeValue })
    this.initializeCardElement()
  }

  disconnect() {
    if (this.cardElement) {
      this.cardElement.destroy()
    }
  }

  private initializeCardElement() {
    if (!this.stripePublishableKeyValue) {
      console.warn('[CardComponent] Stripe publishable key not available')
      return
    }

    if (!this.stripe) {
      this.stripe = Stripe(this.stripePublishableKeyValue)
    }

    this.elements = this.stripe.elements()
    this.cardElement = this.elements.create('card', { hidePostalCode: true })
    this.cardElement.mount(`#${this.cardElementTarget.id}`)
  }

  handleNextAction(clientSecret: string): Promise<any> {
    if (!this.stripe) {
      return Promise.reject(new Error('Stripe not initialized'))
    }
    return this.stripe.handleNextAction({ clientSecret })
  }

  createToken(billingDetails?: any): Promise<any> {
    if (!this.stripe || !this.cardElement) {
      console.warn('[CardComponent] Stripe not initialized')
      return Promise.reject('Stripe not initialized')
    }

    const tokenData: any = {}
    if (billingDetails) {
      tokenData.name = billingDetails.name
      tokenData.address_line1 = billingDetails.address?.line1 || ''
      tokenData.address_line2 = billingDetails.address?.line2 || ''
      tokenData.address_city = billingDetails.address?.city || ''
      tokenData.address_state = billingDetails.address?.state || ''
      tokenData.address_zip = billingDetails.address?.postal_code || ''
      tokenData.address_country = billingDetails.address?.country || ''
      console.log('[CardComponent] Creating token with billing details:', tokenData)
    } else {
      console.log('[CardComponent] Creating token without billing details')
    }

    return this.stripe.createToken(this.cardElement, tokenData).then((result: any) => {
      if (result.error) {
        this.showError(result.error.message)
        return { error: result.error }
      }

      console.log('[CardComponent] Token created successfully:', result.token)
      this.clearError()
      return { token: result.token }
    })
  }

  private showError(message: string): void {
    if (this.hasCardErrorsTarget) {
      this.cardErrorsTarget.textContent = message
    }
  }

  private clearError(): void {
    if (this.hasCardErrorsTarget) {
      this.cardErrorsTarget.textContent = ''
    }
  }
}
